// Single source of truth for UserReceipt `source` values and how a shopper's
// "My Orders" view treats each. To add a new source: add it to RECEIPT_SOURCE,
// add a SHOPPER_ORDER_SOURCES entry if it should appear in My Orders, and add a
// matching `.source-pill.<source>` style in OrderRow.scss (CSS can't read this).
const RECEIPT_SOURCE = {
  GMAIL: 'gmail',
  PLAID: 'plaid',
  MANUAL: 'manual',
  EXTENSION: 'extension'
};

// Imported receipt sources surfaced in "My Orders" (everything else is treated
// as ShopMy-link spend). `label` drives the row's source pill; `hasProducts`
// flags sources that persist a products JSON array.
const SHOPPER_ORDER_SOURCES = {
  [RECEIPT_SOURCE.GMAIL]: { label: 'Gmail', hasProducts: true },
  [RECEIPT_SOURCE.PLAID]: { label: 'Plaid', hasProducts: false },
  [RECEIPT_SOURCE.EXTENSION]: { label: 'Extension', hasProducts: true }
};

const SHOPPER_ORDER_SOURCE_KEYS = Object.keys(SHOPPER_ORDER_SOURCES);
const SHOPPER_ORDER_SOURCES_WITH_PRODUCTS = SHOPPER_ORDER_SOURCE_KEYS.filter(
  source => SHOPPER_ORDER_SOURCES[source].hasProducts
);

module.exports = {
  RECEIPT_SOURCE,
  SHOPPER_ORDER_SOURCES,
  SHOPPER_ORDER_SOURCE_KEYS,
  SHOPPER_ORDER_SOURCES_WITH_PRODUCTS
};
